<template>
  <div id="register-wrapper" :class="{ open: open }">
    <div id="register-box" class="container inner-container">
      <h3>{{ cpLang("login.candidate_register") }}</h3>
      <div class="row overflow-visible">
        <div class="col-xl-4 col-lg-12 col-xs-12 tips-contianer">
          <p>
            {{ cpLang("login.member_tips") }}
          </p>
          <!-- <p v-html="cpLang('login.register_agree')" /> -->
        </div>
        <div class="col-1 d-none d-lg-block d-xl-none">
          &nbsp;
        </div>
        <div class="col-xl-3 col-lg-5 col-sm-6 col-xs-12">
          <div v-if="error" class="text-danger">
            <small>{{ error }}</small>
          </div>
          <form
            @submit.prevent="toggleValClass"
            @keypress.prevent.enter="register()"
            novalidate
          >
            <div class="form-group">
              <input
                id="reg_mail"
                v-model="email"
                :placeholder="cpLang('placeholder.email')"
                @change="validateEmail"
                class="form-control"
                type="text"
                required
              >
            </div>
            <div class="form-group row overflow-visible">
              <div class="col-5 col-sm-6 pr-0 pr-sm-2">
                <input
                  id="reg_pw"
                  v-model="password"
                  :placeholder="cpLang('placeholder.password')"
                  :type="showPassword ? 'text' : 'password'"
                  minlength="8"
                  maxlength="15"
                  class="form-control"
                  required
                >
              </div>
              <div class="col-6 col-sm-6 pl-4 pl-sm-2">
                <input
                  v-model="confirmPassword"
                  :placeholder="cpLang('placeholder.confirm')"
                  :type="showPassword ? 'text' : 'password'"
                  minlength="8"
                  maxlength="15"
                  class="form-control"
                  required
                >
                <i
                  @mousedown="showPassword = true"
                  @mouseup="showPassword = false"
                  :class="{
                    'fa-low-vision': !showPassword,
                    'fa-eye': showPassword,
                  }"
                  class="fas"
                />
                <i
                  @click="showPassword = !showPassword"
                  :class="{
                    'fa-low-vision': !showPassword,
                    'fa-eye': showPassword,
                  }"
                  class="fas"
                />
              </div>
              <div class="clear-both" />
            </div>

            <div class="form-group row overflow-visible">
              <div id="ref-form-gender" class="col-xl-3 col-lg-3 col-sm-3 pr-0">
                <AutoComplete
                  :auto-complete-data="genderList"
                  :input-props="{
                    id: 'gender-reg-txt',
                    placeholder: cpLang('global.select'),
                    value: genderList[0].desc,
                  }"
                  @selected="selectGender"
                  read-only
                  no-icon
                  class="white"
                />
              </div>
              <div class="col-xl-9 col-lg-9 col-sm-9 px-0">
                <div class="col-6">
                  <input
                    id="reg_fname"
                    v-model="firstname"
                    :placeholder="cpLang('apply.firstname')"
                    class="form-control"
                    type="text"
                    required
                  >
                </div>
                <div class="col-6">
                  <input
                    id="reg_lname"
                    v-model="lastname"
                    :placeholder="cpLang('apply.lastname')"
                    class="form-control"
                    type="text"
                    required
                  >
                </div>
              </div>
              <div class="clear-both" />
            </div>
            <div class="form-group">
              <i :class="{ disable: enableVerCode }" class="fas fa-keyboard" />
              <input
                id="reg_code"
                :disabled="enableVerCode"
                v-model="code"
                :placeholder="cpLang('placeholder.verification')"
                class="form-control"
                minlength="4"
                maxlength="4"
                type="text"
                required
              >

              <input
                v-if="sent && countDown"
                :value="countDown + ' s'"
                class="btn btn-primary btn-send btn-xs disabled"
                disabled
                type="button"
              >
              <input
                v-if="sent && !countDown"
                @click="sendVerificationCode"
                :value="cpLang('login.resend')"
                class="btn btn-primary btn-send btn-xs"
                type="button"
              >
              <input
                v-if="!sent"
                @click="sendVerificationCode"
                :value="cpLang('login.forgot_send')"
                class="btn btn-primary btn-send btn-xs"
                type="button"
              >
              <!-- <input v-if="sent && countDown" :value="countDown + ' s'" class="btn btn-xs disabled" disabled type="button">
              <input v-if="sent && !countDown" @click.prevent="sendVerificationCode" :value="cpLang('login.resend')" class="btn btn-xs" type="button"> -->
              <div v-click-outside="() => {showTooltip = false}" class="position-relative">
                <!-- <button v-if="!sent" @click.prevent="sendVerificationCode" type="submit" class="btn btn-primary m-0">
                  {{ cpLang('login.send_code') }}
                </button> -->
                <button
                  @click="sent && agree ? register() : (showTooltip = true)"
                  :disabled="!sent"
                  type="submit"
                  class="btn btn-primary m-0 submit-btn"
                >
                  {{ cpLang("global.submit") }}
                </button>
                <div v-show="showTooltip" class="form-check cs-tooltip">
                  <input
                    v-model="agree"
                    type="checkbox"
                    class="form-check-input my-0"
                  >
                  <span v-html="cpLang('login.register_agree')" class="form-check-label" />
                </div>
              </div>
              <div>
                <p class="pt-2 to-login-btn text-center">
                  {{ cpLang('login.alrady_member') }}
                  <b @click="goToLogin" class="text-primary">{{ cpLang('login.login_here') }}</b>
                </p>
              </div>
              <div class="clear-both" />
            </div>
            <div class="reg-msg">
              <!-- <div v-if="error" class="text-danger">
                <small>{{ error }}</small>
              </div> -->
              <div class="text-success">
                <small>{{ sentVerifyCode }}</small>
              </div>
            </div>
          </form>
        </div>
        <div class="col-1 d-none d-xl-block">
          &nbsp;
        </div>
        <div class="col-xl-3 col-lg-5 col-sm-6 col-xs-12 social-login-wrap">
          <AuthBox />
          <div class="subscriptions">
            <div class="form-check mb-1">
              <div class="l-flex l-align-center">
                <input
                  id="newsletterstatus"
                  v-model="newsLetterStatus"
                  type="checkbox"
                  class="form-check-input my-0"
                >
                <label class="form-check-label" for="newsletterstatus">{{
                  cpLang("profile.edm_newsletter")
                }}</label>
              </div>
            </div>
            <!-- <div class="form-check">
              <div class="l-inline-flex">
                <input id="thirdpartystatus" v-model="thirdPartyStatus" type="checkbox" class="form-check-input">
                <label class="form-check-label" for="thirdpartystatus">{{ cpLang('profile.edm_third_party') }}</label>
              </div>
            </div> -->
            <div class="form-check">
              <div class="l-flex l-align-center">
                <input
                  id="jobalertstatus"
                  v-model="jobAlertStatus"
                  type="checkbox"
                  class="form-check-input my-0"
                >
                <label class="form-check-label" for="jobalertstatus">{{
                  cpLang("profile.edm_job_alert")
                }}</label>
              </div>
            </div>
          </div>
        </div>
        <div class="clear-both" />
      </div>
      <div class="clear-both" />
    </div>
  </div>
</template>

<script>
import AutoComplete from '@/components/global/AutoComplete'
import AuthBox from '../user/AuthBox'
import commonHelper from '~/assets/js/commonHelper.js'

export default {
  components: {
    AuthBox,
    AutoComplete
  },
  props: {
    open: Boolean
  },
  data() {
    return {
      email: '',
      password: '',
      firstname: '',
      confirmPassword: '',
      newsLetterStatus: false,
      jobAlertStatus: false,
      thirdPartyStatus: false,
      agree: false,
      code: '',
      lastname: '',
      countDown: 15,
      timer: false,
      sent: false,
      error: '',
      showPassword: false,
      validEmail: false,
      sentVerifyCode: '',
      enableVerCode: true,
      genderList: [
        { id: 1, desc: this.cpLang('Prof.') },
        { id: 2, desc: this.cpLang('Dr.') },
        { id: 3, desc: this.cpLang('Mr.') },
        { id: 4, desc: this.cpLang('Ms.') },
        { id: 5, desc: this.cpLang('Mrs.') },
        { id: 6, desc: this.cpLang('Miss') }
      ],
      gender: this.cpLang('Prof.'),
      showTooltip: false
    }
  },
  methods: {
    selectGender: function (e) {
      this.gender = e.item.desc
    },
    checkAgree: function () {
      this.agree = !this.agree
    },
    validateEmail: async function () {
      const vm = this
      if (this.username !== '') {
        try {
          const params = { email: this.email }
          const apiRes = await this.$axios.get('candidate/validate', {
            params: params
          })
          if (apiRes.data.status === 'registered') {
            vm.validEmail = false
            vm.error = this.cpLang('login.email_registered')
          }
          if (apiRes.data.status === 'fail') {
            vm.error = this.cpLang('apply.email_invalid')
            vm.validEmail = false
          }
          if (apiRes.data.status === 'success') {
            vm.validEmail = true
            vm.error = ''
          }
        } catch (err) {
          vm.error = err
        }
      }
    },
    validate: function () {
      this.error = ''
      if (!this.validEmail) {
        this.error = this.cpLang('login.email_registered')
        commonHelper.eleFocus('#reg_mail')
        return false
      }
      if (commonHelper.isEmpty(this.email)) {
        this.error = this.cpLang('login.email_required')
        commonHelper.eleFocus('#reg_mail')
        return false
      }
      if (commonHelper.isEmpty(this.password)) {
        this.error = this.cpLang('login.password_required')
        commonHelper.eleFocus('#reg_pw')
        return false
      }
      if (this.password.length < 8 || this.password.length > 15) {
        this.error = this.cpLang('login.password_limit')
        commonHelper.eleFocus('#reg_pw')
        return false
      }
      if (this.password !== this.confirmPassword) {
        this.error = this.cpLang('login.password_not_matched')
        commonHelper.eleFocus('#reg_pw')
        return false
      }
      if (commonHelper.isEmpty(this.firstname)) {
        this.error = this.cpLang('login.firstname_required')
        commonHelper.eleFocus('#reg_fname')
        return false
      }
      if (commonHelper.isEmpty(this.lastname)) {
        commonHelper.eleFocus('#reg_lname')
        this.error = this.cpLang('login.lastname_required')
        return false
      }
      return true
    },
    register: function () {
      if (!this.sent) {
        this.sendVerificationCode()
        return
      }
      this.error = ''
      this.sentVerifyCode = ''
      const vm = this
      if (!vm.validate()) {
        return false
      }
      if (this.sent && this.code === '') {
        this.error = this.cpLang('login.code_required')
        return false
      }
      vm.waiting(1)
      const params = {
        email: this.email,
        password: this.password,
        firstname: this.firstname,
        lastname: this.lastname,
        gender: this.gender,
        newsletterstatus: this.newsLetterStatus ? 'Y' : 'N',
        jobalertstatus: this.jobAlertStatus ? 'Y' : 'N',
        thirdpartystatus: this.thirdPartyStatus ? 'Y' : 'N',
        event: commonHelper.getParameter('utm_source', window.location.href),
        code: this.code
      }
      // await vm.$store.dispatch('user/register', params)
      this.$axios.post('candidate/register', params).then(function (response) {
        vm.waiting(0)
        const status = response.data.status
        if (status === 'registered') {
          vm.validEmail = false
          vm.error = vm.cpLang('login.email_registered')
          return false
        }
        if (status === 'password_invalid') {
          vm.error = vm.cpLang('login.password_limit')
          return false
        }
        if (status === 'email_invalid') {
          vm.error = vm.cpLang('apply.email_invalid')
          return false
        }
        if (status === 'verify_fail') {
          vm.error = vm.cpLang('login.code_invalid')
          return false
        }
        if (status === 'verify_expired') {
          vm.error = vm.cpLang('login.code_expired')
          return false
        }
        vm.waiting(1)
        if (status === 'success') {
          vm.$auth
            .loginWith('local', {
              data: {
                email: vm.email,
                password: vm.password
              }
            })
            .then(() => {
              vm.waiting(0)
              vm.$store.dispatch('user/syncBookmark')
              vm.$router.push({
                path: '/myprofile/landing',
                redirect: 'actualRoute'
              })
            })
            .catch((err) => {
              vm.waiting(0)
              vm.error = err.message
            })
          const event = new Event('closepanel')
          window.dispatchEvent(event)
        }
      })
    },
    sendVerificationCode: async function () {
      const vm = this
      if (!vm.validate()) {
        return false
      }
      vm.waiting(1)
      vm.countDown = 15
      vm.timer = setInterval(function () {
        vm.countDown -= 1
        if (vm.countDown <= 0) {
          vm.countDown = 0
          clearInterval(vm.timer)
        }
      }, 1000)
      const params = { email: this.email, firstname: this.firstname }
      try {
        await this.$axios.get('candidate/verify', { params: params })
        vm.sent = true
        this.enableVerCode = false
        vm.waiting(0)
        // commonHelper.toast(vm.cpLang(vm.cpLang('login.verification_sent'), 'primary')
        vm.sentVerifyCode = vm.cpLang('login.verification_sent')
      } catch (err) {
        vm.waiting(0)
        vm.error = err
      }
    },
    waiting: function (status) {
      commonHelper.cursorWait(status)
    },
    goToLogin: function () {
      // check if in top panel
      if (document.body.id === 'registration-page') {
        this.$router.push({
          path: '/login'
        })
      } else {
        this.$emit('gotologin')
      }
    },
    toggleValClass: function (e) {
      e.target.classList.add('was-validated')
    }
  }
}
</script>
<style lang="scss">
#register-wrapper {
  .form-group{
    margin-bottom: 0;
  }
  select {
    height: 40px;
    border-radius: 20px;
  }
  .col-3 {
    line-height: 1;
    .reg-msg {
      line-height: 1.2;
    }
  }
  .fa-keyboard {
    &.disable {
      color: #c3c3c3 !important;
    }
  }
  #reg_code {
    padding-left: 40px;
    &:disabled {
      &::placeholder {
        color: #c3c3c3;
      }
    }
  }
  .btn-send {
    border-radius: 4px;
    position: absolute;
    right: 22px;
    min-width: auto;
    max-width: 80px;
    top: 9px;
    text-transform: uppercase;
  }
  .text-danger {
    position: relative;
    font-size: 16px;
    text-align: left;
    small {
      position: absolute;
      bottom: 0;
      transform: translateY(-10px);
    }
  }
  .submit-btn{
    opacity: 1;
    &:disabled{
      background: #999 !important;
    }
  }
}
#thirdpartystatus {
  margin-top: 0.3rem;
}
.subscriptions {
  label {
    line-height: 1.5;
  }
}
#agreetnc {
  display: flex;
  label {
    color: #6e6e6e;
  }
}
#ref-form-gender {
  input {
    background: #fff !important;
  }
  .autocomplete-results {
    top: 43px !important;
    z-index: 99 !important;
    ul {
      margin: 0;
    }
  }
}
.cs-tooltip {
  background: #000;
  max-width: 400px;
  color: #fff;
  font-size: 12px;
  padding: 5px 0px;
  display: flex;
  flex-wrap: wrap;
  position: absolute;
  top: -93px;
  line-height: normal;
  border-radius: 5px;
  &:before {
    content: "";
    width: 0;
    height: 0;
    position: absolute;
    margin: 5px;
    z-index: 1;
    bottom: -10px;
    left: 50%;
    transform: translateX(-50%) rotate(45deg);
    border: 5px solid #000;
  }
  a {
    color: #fff;
    text-decoration: underline;
  }
  input {
    width: 7%;
    margin: 0;
    position: relative;
  }
  span {
    color: #fff !important;
    width: 90%;
  }
}
</style>
